import { create } from 'zustand';
import { listMailboxes } from '@/api/mailboxes';
import type { Mailbox } from '@/types';

interface MailState {
  mailboxes: Mailbox[];
  selectedMailbox: Mailbox | null;
  selectedFolder: string;
  isLoading: boolean;
  error: string | null;
  setSelectedMailbox: (mailbox: Mailbox | null) => void;
  setSelectedFolder: (folder: string) => void;
  refreshMailboxes: () => Promise<void>;
  reset: () => void;
}

const initialMailState = { mailboxes: [] as Mailbox[], selectedMailbox: null, selectedFolder: 'INBOX', isLoading: false, error: null };

export const useMailStore = create<MailState>()((set) => ({
  mailboxes: [],
  selectedMailbox: null,
  selectedFolder: 'INBOX',
  isLoading: false,
  error: null,

  // Back to empty on sign-out / sign-in so one user's mailboxes never show for the next (B-06).
  reset: () => set(initialMailState),

  setSelectedMailbox: (mailbox) => set({ selectedMailbox: mailbox }),
  setSelectedFolder: (folder) => set({ selectedFolder: folder }),

  refreshMailboxes: async () => {
    set({ isLoading: true, error: null });
    try {
      const { mailboxes } = await listMailboxes();
      set({ mailboxes, isLoading: false });
    } catch (err: any) {
      set({ error: err.message, isLoading: false });
    }
  }
}));
